// Teklif belgesi ortak yardımcıları — metinler, koşullar, kalem adı biçimlendirme.
// Belge görseli vektörel PDF olarak `lib/quotePdf.js` içinde üretilir (önizleme = indirilen PDF).

export const STATUS = { taslak: "Taslak", gonderildi: "Gönderildi", degerlendiriliyor: "Değerlendiriliyor", kabul: "Kabul Edildi", red: "Reddedildi" };
export const PAY_TEXT = {
  havale_kredi: "Fiyatlarımız havale / kredi kartı ödemeye göre verilmiştir.",
  havale_nakit: "Fiyatlarımız havale / nakit ödemeye göre verilmiştir.",
  kredi_karti: "Fiyatlarımız kredi kartı ödemesine göre verilmiştir.",
  cek: "Fiyatlarımız vadeli (çek) ödemeye göre verilmiştir.",
};
export const DEFAULT_TERMS = [
  "Teklifimiz, teklif tarihinden itibaren 1 iş günü süreyle geçerlidir.",
  "Döviz bazlı ürünlerde, fatura tarihindeki TCMB Döviz Satış Kuru esas alınacaktır.",
  "{ODEME}",
  "{KDV}",
  "Teklifimiz bir bütün olarak geçerli olup, ürünlerin kısmi olarak sipariş edilmesi durumunda fiyatlar yeniden değerlendirilebilir.",
  "Ürünlerin teslim süresi stok durumuna göre değişiklik gösterebilir.",
];
const PAY_LINE = {
  havale_kredi: "Belirtilen fiyatlar HAVALE/EFT veya KREDİ KARTI ile ödeme koşullarına göre hazırlanmıştır.",
  havale_nakit: "Belirtilen fiyatlar HAVALE/EFT veya NAKİT ile ödeme koşullarına göre hazırlanmıştır.",
  kredi_karti: "Belirtilen fiyatlar KREDİ KARTI ile ödeme koşullarına göre hazırlanmıştır.",
  cek: "Belirtilen fiyatlar VADELİ (ÇEK) ödeme koşuluna göre hazırlanmıştır.",
};

// KDV'siz cari + KDV hesaplanmamış teklif → "fiyatlar KDV hariç" gösterimi. KDV'siz cariye KDV'li teklif verilirse normal (KDV dahil) gösterilir.
export const quoteVatExempt = (q) => !!(q && q.vat_exempt && !(Number(q.kdv) > 0));

const norm = (s) => String(s || "").trim().toLocaleUpperCase("tr");
// Satır adı: MARKA + ürün adı (marka ad içinde zaten geçiyorsa tekrar etmez)
export const itemDisplayName = (it, { showBrand = true } = {}) => {
  const name = String(it.name || "").trim();
  const brand = String(it.brand || "").trim();
  if (!brand) return name;
  const startsWithBrand = norm(name).startsWith(`${norm(brand)} `) || norm(name) === norm(brand);
  if (!showBrand) return startsWithBrand ? name.slice(brand.length).trim() || name : name;
  return startsWithBrand ? name : `${brand.toLocaleUpperCase("tr")} ${name}`;
};
// Alt satırlar: opsiyonel kod + (markadan farklı) açıklama
export const itemSubLines = (it, { showCodes = false } = {}) => {
  const out = [];
  if (showCodes && it.code) out.push(`Kod: ${it.code}`);
  const d = String(it.description || "").trim();
  if (d && norm(d) !== norm(it.brand)) out.push(d);
  return out;
};

export function resolveQuoteTerms(q, terms) {
  const base = (q && q.terms && q.terms.length) ? q.terms : ((terms && terms.length) ? terms : DEFAULT_TERMS);
  const vatExempt = quoteVatExempt(q);
  const pay = PAY_LINE[(q && q.payment_terms) || "havale_kredi"] || PAY_LINE.havale_kredi;
  // KDV dahil tekliflerde koşullarda KDV satırı YAZILMAZ (kullanıcı kararı); KDV hariçte yalnızca sade bir "+KDV" açıklaması.
  const kdvLine = (vatExempt || !(Number(q?.kdv_rate) > 0)) ? "Fiyatlarımız KDV hariçtir (+KDV)." : "";
  const out = base.map((l) => String(l).replace(/\{ODEME\}/g, pay).replace(/\{KDV\}/g, kdvLine).trim()).filter(Boolean);
  // Seçilen ödeme şekli her zaman açıklamalarda yer alır (şablon {ODEME} içermese bile)
  if (!base.some((l) => /\{ODEME\}/.test(String(l)))) out.splice(Math.min(1, out.length), 0, pay);
  return out;
}

// Teklif geçerlilik durumu (liste rozetleri için): expired | soon (≤2 gün) | ok | null
export function validityState(q) {
  if (!q?.valid_until || q.status === "kabul" || q.status === "red") return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const v = new Date(String(q.valid_until).slice(0, 10)); v.setHours(0, 0, 0, 0);
  const days = Math.round((v - today) / 86400000);
  if (days < 0) return { state: "expired", days };
  if (days <= 2) return { state: "soon", days };
  return { state: "ok", days };
}
